import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import moment from "moment";
import { ApplicationIcon, EditIcon, GroupIcon, UserIcon } from "../../assets/Icons";
import { BtnAddGroupIcon, BtnAddUserIcon, BtnAssignAppIcon, InfoIcon } from "../../Icons";
import SettingTeamManagement from "../SettingTeamManagement";
import PasswordChangeModal from "../../modal/PasswordChangeModal";
import { useModalContext } from "../../modal/context/ModalProvider";
import apiClient from "../../apiClient";
import { GROUP_DETAILS } from "../../apiClient/apiEndpoints";
import { checkPermission, checkPermissionExist, getPlaceholderName } from "../../utils/general";
import { toolTip } from "../Tooltips/CustomTooltip";
import { GROUP_TAB_TYPE } from "../../constant/constants";
import {
  GROUP_CREATE_PERMISSION,
  GROUP_SETTINGS_PERMISSION,
  NULL,
  RESOURCE_REVOKE_PERMISSION,
  USER_CREATE_PERMISSION,
} from "../../constant/permission";

const { IconButton, SimModal, SimTooltip, ConfirmBox } = UiComponents;

const GroupInfoPanel = ({ details, getGroupDetails, handleRefreshTab, params, isMobileView }) => {
  const { openModal } = useModalContext();
  const [passwordModal, setPasswordModal] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const navigate = useNavigate();

  const handleRefreshTabTrigger = () => {
    handleRefreshTab();
    getGroupDetails();
  };

  const handleAssignAppClick = (data) => {
    let selectedData = {
      type: GROUP_TAB_TYPE,
      items: [{ name: details.name, uuid: details.uuid, avatar: details?.avatar || null }],
    };
    navigate(`/resource-management/${GROUP_TAB_TYPE}/${params.uuid}`, { state: { selectedData } });
  };

  const groupActions = [
    {
      text: "Group",
      icon: <GroupIcon />,
      permission: GROUP_CREATE_PERMISSION,
      onClick: () =>
        openModal({
          modalName: "GROUP_ADD",
          type: "create",
          id: null,
          params,
          handleRefreshTab: handleRefreshTabTrigger,
        }),
    },
    {
      text: "User",
      permission: USER_CREATE_PERMISSION,
      icon: <UserIcon />,
      onClick: () =>
        openModal({
          modalName: "USER_ADD",
          type: "create",
          id: null,
          params,
          handleRefreshTab: handleRefreshTabTrigger,
        }),
    },
    {
      text: "Application",
      permission: RESOURCE_REVOKE_PERMISSION,
      icon: <ApplicationIcon nAppIcon />,
      onClick: () => handleAssignAppClick(),
    },
  ];

  let groupActionsFilter = groupActions.filter((item) => { return checkPermissionExist(item.permission) });

  const avatarSrc = details?.avatar;
  const userName = details?.name;

  return (
    <>
      {!isMobileView ? (
        <div className="parent-group">
          <div className="group-function-parent">
            <div className="group-info">
              <div className="profile">
                <div className="bg">
                  {avatarSrc && !imageError ? (
                    <img
                      src={avatarSrc}
                      referrerPolicy="no-referrer"
                      onError={() => setImageError(true)}
                      alt="avatar"
                    />
                  ) : (
                    <span className="initials">{getPlaceholderName(userName)}</span>
                  )}
                </div>
              </div>

              <p className="name">{details.name}</p>
              {details?.identifier && <p className="groupid m-0">{details?.identifier}</p>}
              {details?.type?.name && <p className="Tag"> {details?.type?.name || null} </p>}

              <div className="action-btn ">
                {groupActionsFilter.map(({ text, icon, onClick }) => (
                  <SimTooltip key={text} text={text} placement="top">
                    <div className="Icon-btn">
                      <IconButton Icon={icon} onClick={onClick} />
                    </div>
                  </SimTooltip>
                ))}
              </div>
            </div>

            <div className="group-functions">
              <>
                <div className="function-item">
                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Total Groups </p>
                      <div className="text-output">
                        {details.groups || 0}
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={toolTip({ text: `This is a total groups inside ${details.name}` })}
                        >
                          <span>
                            <InfoIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>

                  <div className="group-info-item">
                    <div className="text-detail">
                      <p> Total Users </p>
                      <div className="text-output">
                        {details.users || 0}
                        <OverlayTrigger
                          placement="right"
                          delay={{ show: 250, hide: 400 }}
                          overlay={toolTip({ text: `This is a total users inside ${details.name}` })}
                        >
                          <span>
                            <InfoIcon />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                </div>

                {checkPermissionExist(GROUP_SETTINGS_PERMISSION) && (
                  <SettingTeamManagement type="group" getGroupDetails={getGroupDetails} />
                )}
              </>
            </div>
          </div>

          <div className="group-edit">
            {checkPermissionExist(GROUP_CREATE_PERMISSION) && (
              <span
                className="edit-btn"
                onClick={() =>
                  openModal({
                    modalName: "GROUP_ADD",
                    type: "update",
                    id: details.uuid,
                    params,
                    getGroupDetails,
                  })
                }
              >
                Edit <EditIcon />
              </span>
            )}

            <p>
              GROUP SINCE:
              {moment(details.createdAt).format("LL")}
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className={checkPermissionExist(GROUP_CREATE_PERMISSION) ? "team-infoMob" : "team-infoMob no-edit"}>
            <div className="LogonInfo">
              <div className="logoWrapper">
                {avatarSrc && !imageError ? (
                  <img src={avatarSrc} referrerPolicy="no-referrer" onError={() => setImageError(true)} alt="avatar" />
                ) : (
                  <span className="initials">{getPlaceholderName(userName)}</span>
                )}
              </div>
              <div className="infoWrapper">
                <span className="name">{details.name}</span>

                {details?.identifier && <span className="groupId">{details?.identifier}</span>}
              </div>
            </div>
            <div className="groupStats">
              <span className="statItem">
                <p>{details.groups || 0}</p>
                <span>Total Groups </span>
              </span>
              <span className="statItem">
                <p>{details.users || 0}</p>
                <span>Total Users </span>
              </span>
            </div>
            {checkPermissionExist(GROUP_CREATE_PERMISSION) && (
              <span
                className="editIcon"
                onClick={() =>
                  openModal({
                    modalName: "GROUP_ADD",
                    type: "update",
                    id: details.uuid,
                    params,
                    getGroupDetails,
                  })
                }
              >
                Edit Profile
              </span>
            )}
          </div>
        </>
      )}

      <SimModal showModal={passwordModal} onHide={() => setPasswordModal(false)} centered={true} size="md">
        <PasswordChangeModal onHide={() => setPasswordModal(false)} />
      </SimModal>

      <ConfirmBox
        showModal={confirmModal}
        alertTitle="Added"
        ActionButtonItem="Save"
        onHide={() => setConfirmModal(false)}
        alertMessage="Are you sure?"
      />
    </>
  );
};

export default GroupInfoPanel;
